import React from 'react';
import { Box } from '@material-ui/core';
import config from '@/configs/config';

const howToUseFooSpace = {
  icon: '/images/FAQ/icon_manual.png',
  title: `如何使用${config.BrandNameTW}`,
  id: 'how_to_use_foospace',
  children: [
    {
      title: '直接買機台內的商品',
      id: 'how_to_buy_from_fridge',
      content: [
        <Box key="how_to_buy_from_fridge_1">1・「刷卡開門」</Box>,
        <Box key="how_to_buy_from_fridge_2">請輕觸螢幕，並選擇「刷實體信用卡」或「LINE Pay掃QRcode」啟動程序（有購餐才扣款）。</Box>,
        <Box key="how_to_buy_from_fridge_3" mt={1}>2・「輸入手機號碼」</Box>,
        <Box key="how_to_buy_from_fridge_4">手機號碼為發送收據之用，確認輸入號碼後，等待櫃門解鎖，即可開啟服務。</Box>,
        <Box key="how_to_buy_from_fridge_5" mt={1}>3・「選擇機台購餐」</Box>,
        <Box key="how_to_buy_from_fridge_6">
          開門拿取想要的商品，關上門後就完成啦！系統將自動判讀您選擇的商品後自動結帳，並發送明細至
          {config.BrandNameTW}
          LINE官方帳號。
        </Box>,
        <img key="how_to_buy_from_fridge_7" src={`${config.RESOURCE_URI}FAQ_info_new_1.jpg`} alt="" width="100%" style={{ marginTop: 16 }} />,
      ],
    },
    {
      title: '線上預訂，在機台取貨',
      id: 'how_to_buy_from_online',
      content: [
        <Box key="how_to_buy_from_online_1">
          您可以預訂
          <a href="/menu">每日架上鮮食</a>
          上任何顯示【可預訂】的商品。
        </Box>,
        <Box key="how_to_buy_from_online_2">【訂購流程】</Box>,
        <Box key="how_to_buy_from_online_3">
          1・「我的
          {config.BrandNameTW}
          在..」設定顯示在您要取貨的地點。
        </Box>,
        <Box key="how_to_buy_from_online_4">2・找到頁面上標示【可預訂】的商品。</Box>,
        <Box key="how_to_buy_from_online_5">3・點擊預訂按鈕後即可進入訂購流程。</Box>,
        <Box key="how_to_buy_from_online_6" mt={1}>【取貨流程】</Box>,
        <Box key="how_to_buy_from_online_7">
          1・請務必先加入
          {config.BrandNameTW}
          LINE好友，以收到貨到通知訊息。
        </Box>,
        <Box key="how_to_buy_from_online_8">2・商品上架後，LINE將會收到專屬預訂取貨碼。</Box>,
        <Box key="how_to_buy_from_online_9">3・至指定機台，刷卡或LINE Pay開啟操作，於螢幕點選「預購取貨」。</Box>,
        <Box key="how_to_buy_from_online_10">4・輸入六位數取貨碼。</Box>,
        <Box key="how_to_buy_from_online_11">5・開門取貨即完成。</Box>,
        <img key="how_to_buy_from_online_12" src={`${config.RESOURCE_URI}FAQ_info_new_2.jpg`} alt="" width="100%" style={{ marginTop: 16 }} />,
      ],
    },
    {
      title: '可以用什麼方式付款?',
      id: 'how_to_pay',
      content: [
        <Box key="how_to_pay_1">我們目前支援以下付款方式：</Box>,
        <Box key="how_to_pay_2" mt={1}>1・信用卡（VISA / Mastercard）。</Box>,
        <Box key="how_to_pay_3">2・LINE Pay支付（如需使用LINE Point折抵，請務必於首次掃碼後勾選）。</Box>,
        <Box key="how_to_pay_4">3・請輕觸螢幕，並選擇「刷信用卡」或「LINE Pay掃QRcode」即可啟動程序（有購餐才扣款）。</Box>,
      ],
    },
    {
      title: `為什麼要加入${config.BrandNameTW}的LINE？`,
      id: 'why_would_I_join_foospace_line',
      content: [
        <Box key="why_would_I_join_foospace_1">
          加入
          {config.BrandNameTW}
          LINE官方帳號，輕鬆享有會員專屬服務：
        </Box>,
        <Box key="why_would_I_join_foospace_2">1・領取最高五折優惠券與購物金。</Box>,
        <Box key="why_would_I_join_foospace_3">2・商品到貨通知不漏接。</Box>,
        <Box key="why_would_I_join_foospace_4">3・最新活動優惠。</Box>,
        <Box key="why_would_I_join_foospace_5">4・查詢收據明細。</Box>,
        <Box key="why_would_I_join_foospace_6" mt={1}>
          現在就加入
          {config.BrandNameTW}
          <a href="https://lin.ee/W6PWbqF">LINE官方帳號</a>
        </Box>,
      ],
    },
  ],
};

const orderAndDiscount = {
  icon: '/images/FAQ/icon_money.png',
  title: '訂單與優惠',
  id: 'order_and_discount',
  children: [
    {
      title: '我的收據內容 / 結帳金額有誤',
      id: 'wrong_receipt',
      content: [
        <Box key="wrong_receipt_1">可能因以下狀況造成您的收據內容 / 結帳金額 有誤：</Box>,
        <Box key="wrong_receipt_2">1・未顯示購買的商品與金額：</Box>,
        <Box key="wrong_receipt_3">如因結帳時外部網路環境不良，有可能造成收據無法正常顯示。我們將立即回報電信業者，且該筆商品不會再向您重新收取費用。</Box>,
        <Box key="wrong_receipt_4" mt={1}>2・收據內容 / 結帳金額顯示出未購買之商品：</Box>,
        <Box key="wrong_receipt_5">請立即聯繫專人客服，我們將協助您釐清原因，並提供差價退款等後續協助。</Box>,
      ],
    },
    {
      title: '優惠券該如何使用？',
      id: 'how_to_use_coupon',
      content: [
        <Box key="how_to_use_coupon_1">【機台直接購餐】</Box>,
        <Box key="how_to_use_coupon_2">
          只要符合優惠卷使用條件，系統將自動在您結帳時進行優惠折抵，您可於消費完成後，於
          {config.BrandNameTW}
          LINE官方帳號上查看收據明細。
        </Box>,
        <Box key="how_to_use_coupon_3" mt={1}>【線上預訂】</Box>,
        <Box key="how_to_use_coupon_4">可於預訂結帳流程，選擇套用優惠券，方可進行折抵。</Box>,
      ],
    },
    {
      title: '我的訂單沒有折扣到優惠活動？',
      id: 'why_no_discount',
      content: [
        <Box key="why_no_discount_1">可能因以下狀況造成您的訂單沒有折扣到優惠活動：</Box>,
        <Box key="why_no_discount_2" mt={1}>1・您購買的非優惠活動品項，或未符合優惠活動之內容。</Box>,
        <Box key="why_no_discount_3">2・購買時已超過優惠活動時間 。</Box>,
        <Box key="why_no_discount_4">3・該營業地點不適用於該優惠活動。</Box>,
        <Box key="why_no_discount_5" mt={1}>如非以上原因，請立即聯繫專人客服，我們將為您提供協助。</Box>,
      ],
    },
    {
      title: '為什麼我沒有拿到首購優惠？',
      id: 'why_no_first_purchase_discount',
      content: [
        <Box key="why_no_first_purchase_discount_1">可能因以下狀況造成您的訂單沒有折扣到優惠活動：</Box>,
        <Box key="why_no_first_purchase_discount_2" mt={1}>1・首購優惠卷需於『第一次購餐前』完成註冊流程才能取得。</Box>,
        <Box key="why_no_first_purchase_discount_3">
          2・如您尚未完成註冊程序，請先點擊「
          <a href="/register" target="_blank" rel="noopener noreferrer">這裡</a>
          」完成註冊，或聯繫專人客服為您服務。
        </Box>,
        <Box key="why_no_first_purchase_discount_4">3・如您已取得首購優惠券，請注意該券使用期限為一週內。</Box>,
      ],
    },
    {
      title: '為什麼信用卡被刷1塊錢呢？',
      id: 'why_charge_one_dollar',
      content: [
        <Box key="why_charge_one_dollar_1">為確認您的信用卡為有效卡片，我們將進行一筆1元交易。請放心，在您完成該次交易後（含零元交易）將自動退還於您的信用卡。</Box>,
      ],
    },
    {
      title: '電子發票相關說明',
      id: 'electronic_receipt_usage',
      content: [
        <Box key="electronic_receipt_usage_1">【如何索取電子發票】</Box>,
        <Box key="electronic_receipt_usage_2">1・於官網登入後，點擊選單內的【編輯會員資料】。</Box>,
        <Box key="electronic_receipt_usage_3">2・填寫【發票資訊】。</Box>,
        <Box key="electronic_receipt_usage_4">3・之後電子發票即會寄到您所填信箱或綁定載具。</Box>,
        <Box key="electronic_receipt_usage_5" mt={1}>【如何查詢過往的電子發票紀錄】</Box>,
        <Box key="electronic_receipt_usage_6">請將您綠界會員載具歸戶後，即可於財政部系統查詢先前所有發票紀錄。</Box>,
        <Box key="electronic_receipt_usage_7" mt={1}>【關於發票折讓】</Box>,
        <Box key="electronic_receipt_usage_8">
          1・電子發票開立即申報，請登入會員後，點選「編輯會員資料」，並勾選【我同意辦理退款時，由
          {config.BrandNameTW}
          代為處理電子發票折讓事宜，以加速退款作業】。
        </Box>,
        <Box key="electronic_receipt_usage_9">
          2・如您是在
          {config.BrandNameTW}
          LINE上收到退款按鈕，可點擊後進入退款頁面，輸入取貨碼並勾選【我同意由
          {config.BrandNameTW}
          代為處理電子發票折讓事宜，以加速退款作業】。
        </Box>,
        <Box key="electronic_receipt_usage_10" mt={1}>【其他】</Box>,
        <Box key="electronic_receipt_usage_11">1・電子發票將於您資料設定完成後進行開通。如未設定，則需自行至綠界以電話號碼登入後查詢發票明細。</Box>,
        <Box key="electronic_receipt_usage_12">2・請注意，消費完成後，須待銀行端確認請款成功後方可開立發票，消費明細將寄至您的信箱。</Box>,
        <Box key="electronic_receipt_usage_13">3・結算後該筆訂單如為0元，將不會開立發票。</Box>,
        <Box key="electronic_receipt_usage_14">
          4・開立發票後如需退款，請聯繫
          {config.BrandNameTW}
          LINE專人客服。
        </Box>,
      ],
    },
  ],
};
const order = {
  icon: '/images/FAQ/icon_shoppingcart.png',
  title: '預訂相關問題',
  id: 'order_question',
  children: [
    {
      title: '如何預訂商品？',
      id: 'how_to_order_an_item',
      content: [
        <Box key="how_to_order_an_item_1">
          您可以預訂
          <a href="/menu">每日架上鮮食</a>
          上任何顯示【可預訂】的商品。
        </Box>,
        <Box key="how_to_order_an_item_2" mt={1}>【訂購流程】</Box>,
        <Box key="how_to_order_an_item_3">
          1・「我的
          {config.BrandNameTW}
          在..」設定顯示在您要取貨的地點。
        </Box>,
        <Box key="how_to_order_an_item_4">2・找到頁面上標示【可預訂】的商品。</Box>,
        <Box key="how_to_order_an_item_5">3・點擊預訂按鈕後即可進入訂購流程。</Box>,
        <Box key="how_to_order_an_item_6" mt={1}>【取貨流程】</Box>,
        <Box key="how_to_order_an_item_7">
          1・請務必先加入
          {config.BrandNameTW}
          LINE好友，以收到貨到通知訊息。
        </Box>,
        <Box key="how_to_order_an_item_8">2・商品上架後，LINE將會收到專屬預訂取貨碼。</Box>,
        <Box key="how_to_order_an_item_9">3・至指定機台，刷卡或LINE Pay開啟操作，於螢幕點選「預購取貨」。</Box>,
        <Box key="how_to_order_an_item_10">4・輸入六位數取貨碼。</Box>,
        <Box key="how_to_order_an_item_11">5・開門取貨即完成。</Box>,
        <img key="how_to_order_an_item_12" src={`${config.RESOURCE_URI}FAQ_info_new_2.jpg`} alt="" width="100%" style={{ marginTop: 16 }} />,
      ],
    },
    {
      title: '哪些據點可以領貨？',
      id: 'where_can_get_items',
      content: [
        <Box key="where_can_get_items_1">
          1・請於
          {config.BrandNameTW}
          LINE官方帳號上點擊「其他服務」
          {'>'}
          「查看據點」，或於
          {config.BrandNameTW}
          官網選擇「營業據點」。
        </Box>,
        <Box key="where_can_get_items_2">2・部分據點為私人產業，不對外開放取貨服務，敬請見諒。</Box>,
      ],
    },
    {
      title: '能否更改取貨地點？',
      id: 'can_i_change_location',
      content: [
        <Box key="can_i_change_location_1">請立即聯繫專人客服，我們將為您提供協助。</Box>,
      ],
    },
    {
      title: '可不可以取消訂單？如何取消？',
      id: 'cancel_order',
      content: [
        <Box key="cancel_order_1">【結單前取消訂單】</Box>,
        <Box key="cancel_order_2">
          如需取消訂單，最晚請在
          <b>結單日前三天</b>
          通知客服人員處理。
        </Box>,
        <Box key="cancel_order_3">如於之後取消或預訂，因已下單製作，恕不接受取消訂單與退款，訂購前請h務必考慮清楚，敬請見諒。</Box>,
        <Box key="cancel_order_4" mt={1}>【結單後取消訂單】</Box>,
        <Box key="cancel_order_5">依消保法第十九條第二項及行政院公佈之通訊交易解除權合理例外情事適用準則，由於商品屬「易於腐敗、保存期限較短或解約時即將逾期」之商品，解約後將無法再出售，因此恕不接受取消訂單與退款，敬請見諒。</Box>,
        <Box key="cancel_order_6" mt={1}>如進入退款程序，款項將於「預購取貨時間結束後」進行退款作業，刷退款項完成時間依發卡銀行端作業時間為準。</Box>,
      ],
    },
    {
      title: '可以取貨的時間？',
      id: 'what_time_can_pick_up',
      content: [
        <Box key="what_time_can_pick_up_1">1・商品屬需保鮮之產品，為維護最佳賞味品質，請務必於收到到貨通知「當日」完成取貨！</Box>,
        <Box key="what_time_can_pick_up_2">2・如於規定之取貨時段內未完成取貨，基於食品安全考量，商品將會下架處理。</Box>,
        <Box key="what_time_can_pick_up_3">3・商品下架後，恕不接受取消訂單與退款，訂購前請務必確認可配合本次商品取貨時段。</Box>,
      ],
    },
    {
      title: '超過取貨時間還可以取貨嗎？',
      id: 'over_time',
      content: [
        <Box key="over_time_1">1・如於規定之取貨時段內未完成取貨，基於食品安全考量，商品將會下架處理。</Box>,
        <Box key="over_time_2">2・如未於規定時間取貨，恕不接受取消訂單與退款，訂購前請務必確認可配合本次商品取貨時段。</Box>,
      ],
    },
    {
      title: '取貨碼要怎麼用？',
      id: 'how_to_use_pick_up_code',
      content: [
        <Box key="how_to_use_pick_up_code_1">取貨碼可取所有您已預訂且於預計領取時段之商品。</Box>,
        <Box key="how_to_use_pick_up_code_2" mt={1}>1・每組取貨碼都有使用期限（請注意，取貨碼有效時間不等於取貨時間）。</Box>,
        <Box key="how_to_use_pick_up_code_3">2・可於官網上查詢您目前的取貨碼及取貨碼的效期。</Box>,
        <Box key="how_to_use_pick_up_code_4">3・如取貨碼到期，請重新整理頁面以取得最新一組動態取貨碼。</Box>,
        <Box key="how_to_use_pick_up_code_5">4・如需他人代領您預訂的商品，請務必輸入屬於您的最新一組動態取貨碼。</Box>,
        <img key="how_to_use_pick_up_code_6" src={`${config.RESOURCE_URI}FAQ_info_new_3.jpg`} alt="" width="100%" style={{ marginTop: 16 }} />,
      ],
    },
    {
      title: '能否請朋友幫我代取預訂的商品？',
      id: 'pick_up_instead',
      content: [
        <Box key="pick_up_instead_1">如需他人代領預訂商品，訂購者請務必提供對方最新一組動態取貨碼。</Box>,
        <Box key="pick_up_instead_2" mt={1}>1・刷卡或掃碼開門(不必使用訂購者本人的信用卡)。</Box>,
        <Box key="pick_up_instead_3">2・輸入待領者的手機號碼。</Box>,
        <Box key="pick_up_instead_4">3・點選【預購取貨】。</Box>,
        <Box key="pick_up_instead_5">4・輸入訂購者提供的取貨代碼。</Box>,
        <Box key="pick_up_instead_6">5・開門完成取貨。</Box>,
        <Box key="pick_up_instead_7" mt={1}>
          後續若有其他問題，請聯繫
          {config.BrandNameTW}
          LINE專人客服。
        </Box>,
      ],
    },
    {
      title: '拿錯東西怎麼辦？我可以再放回去嗎？',
      id: 'pick_up_wrong_thing',
      content: [
        <Box key="pick_up_wrong_thing_1">1・商品上都有標示，請務必確認標示內容後再領取。</Box>,
        <Box key="pick_up_wrong_thing_2">2・為維護食品安全，請不要再放回冰箱內。</Box>,
        <Box key="pick_up_wrong_thing_3">3・請注意，關上冰箱門後即自動結帳，放回冰箱並不會退回款項。</Box>,
        <Box key="pick_up_wrong_thing_4" mt={1}>請立即聯繫專人客服，我們將為您提供協助。</Box>,
      ],
    },
    {
      title: '我在冰箱前，但沒看到我預訂的商品怎麼辦？',
      id: 'can_not_see_my_booking_commodity',
      content: [
        <Box key="can_not_see_my_booking_commodity_1">可能因以下狀況造成您無法領取預購商品：</Box>,
        <Box key="can_not_see_my_booking_commodity_2" mt={1}>1・您選擇的是其他取貨地點。</Box>,
        <Box key="can_not_see_my_booking_commodity_3">2・已超過取貨時間。</Box>,
        <Box key="can_not_see_my_booking_commodity_4" mt={1}>如非以上原因，請立即聯繫專人客服，我們將為您提供協助。</Box>,
      ],
    },
    {
      title: '我沒有預訂這個東西耶，在冰箱看到直接買可以嗎？',
      id: 'can_i_buy_not_booking_commodity',
      content: [
        <Box key="can_i_buy_not_booking_commodity_1">1・請注意，預訂商品僅開放給「已預訂之消費者取貨」</Box>,
        <Box key="can_i_buy_not_booking_commodity_2">2・如您因故直接領取他人之預購商品，除給付該商品價格外，將額外酌收物流費用200元與商品處理費200元。</Box>,
        <img key="can_i_buy_not_booking_commodity_3" src={`${config.RESOURCE_URI}FAQ_info_new_4.jpg`} alt="" width="100%" style={{ marginTop: 16 }} />,
      ],
    },
  ],
};

const products = {
  icon: '/images/FAQ/icon_food.png',
  title: '商品相關問題',
  id: 'products',
  children: [
    {
      title: '我購買的餐點似乎有異常',
      id: 'meal_somehow_weird',
      content: [
        <Box key="meal_somehow_weird_1">如您購買的餐點有瑕疵，請立即聯繫專人客服，將有專人為您處理。</Box>,
      ],
    },
    {
      title: '拿錯東西怎麼辦？我可以再放回去嗎？',
      id: 'pick_up_wrong_thing',
      content: [
        <Box key="pick_up_wrong_thing_1">1・商品上都有標示，請務必確認標示內容後再領取。</Box>,
        <Box key="pick_up_wrong_thing_2">2・為維護食品安全，請不要再放回冰箱內。</Box>,
        <Box key="pick_up_wrong_thing_3">3・請注意，關上冰箱門後即自動結帳，放回冰箱並不會退回款項。</Box>,
        <Box key="pick_up_wrong_thing_4" mt={1}>請立即聯繫專人客服，我們將為您提供協助。</Box>,
      ],
    },
  ],
};

export default config.faqDataOverwrite || [
  howToUseFooSpace,
  orderAndDiscount,
  order,
  products,
];
